import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {WorkPlace} from '../../../classes/WorkPlace';
import {Subject} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Room} from '../../../classes/Room';
import {RoomService} from '../../../services/room.service';

@Component({
  selector: 'app-workplace-edit',
  styleUrls: ['./workplace-edit.component.scss'],
  templateUrl: './workplace-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class WorkPlaceEditComponent implements OnInit {

  @Input() workPlace: WorkPlace;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  rooms: Room[];

  public workPlaceForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private roomService: RoomService) {}

  ngOnInit(): void {

    if (this.workPlace) {
      this.workPlaceForm = this.formBuilder.group({
        id: [this.workPlace.id],
        name: [this.workPlace.name, Validators.required],
        roomName: [this.workPlace.roomName, Validators.required]
      });
    } else {
      this.workPlaceForm = this.formBuilder.group({
        id: [''],
        name: ['', Validators.required],
        roomName: ['', Validators.required]
      });
    }

    this.roomService.getAll().subscribe({
      next: (rooms: Room[]) => this.rooms = rooms,
      error: err => console.log(err.error) // TODO handle error
    });
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
